import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
// Simple counter component for the animated numbers
function Counter({
  end,
  suffix = '',
  duration = 2
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let startTime;
      let animationFrame;
      const updateCount = timestamp => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const percentage = Math.min(progress / (duration * 1000), 1);
        // Easing function (easeOutExpo)
        const easeOut = percentage === 1 ? 1 : 1 - Math.pow(2, -10 * percentage);
        setCount(Math.floor(end * easeOut));
        if (percentage < 1) {
          animationFrame = requestAnimationFrame(updateCount);
        }
      };
      animationFrame = requestAnimationFrame(updateCount);
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [end, duration, isInView]);
  return <span ref={ref} data-id="element-169">
      {count}
      {suffix}
    </span>;
}
const metrics = [{
  value: 200,
  suffix: '+',
  label: 'Proyectos entregados'
}, {
  value: 95,
  suffix: '%',
  label: 'Satisfacción de clientes'
}, {
  value: 3,
  suffix: 'x',
  label: 'Crecimiento promedio'
}, {
  value: 24,
  suffix: '/7',
  label: 'Automatización activa'
}];
export function ValueSection() {
  return <section id="valor" className="py-24 relative z-10 bg-brand-dark/50 border-y border-white/5" data-id="element-170">
      <div className="container mx-auto px-6 md:px-12" data-id="element-171">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-172">
          {/* Text Content */}
          <div className="lg:w-1/2" data-id="element-173">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} data-id="element-174">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-175">
                Eficiencia impulsada por <br data-id="element-176" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-brand-blue" data-id="element-177">
                  Inteligencia Artificial
                </span>
              </h2>
              <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-178">
                No solo construimos sitios web; creamos máquinas de crecimiento.
                Nuestro enfoque combina desarrollo de vanguardia con
                automatización inteligente para asegurar que tu negocio opere a
                su máxima capacidad, reduciendo fricciones y maximizando
                conversiones.
              </p>

              <ul className="space-y-4 mb-10" data-id="element-179">
                {['Procesos optimizados y escalables', 'Decisiones basadas en datos reales', 'Integración perfecta entre plataformas', 'Soporte técnico especializado'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-180">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-cyan" data-id="element-181"></div>
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>

          {/* Metrics Grid */}
          <div className="lg:w-1/2 w-full" data-id="element-182">
            <div className="grid grid-cols-2 gap-6" data-id="element-183">
              {metrics.map((metric, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="glass-panel p-8 rounded-2xl border border-white/5 flex flex-col items-center justify-center text-center hover:bg-white/[0.02] transition-colors" data-id="element-184">
                  <div className="text-4xl md:text-5xl font-bold text-white mb-2 font-mono" data-id="element-185">
                    <Counter end={metric.value} suffix={metric.suffix} data-id="element-186" />
                  </div>
                  <div className="text-sm text-brand-cyan font-medium uppercase tracking-wider" data-id="element-187">
                    {metric.label}
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}